import * as Highcharts from 'highcharts';

export const timePhaseChartOptions: Highcharts.Options = {
  chart: {
    type: 'xrange',
    width: 540,
    height: 120,
    marginRight: 20,
    marginLeft: 20,
  },
  legend: {
    enabled: false,
  },
  title: {
    text: '',
  },
  rangeSelector: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  scrollbar: {
    enabled: false,
  },
  plotOptions: {
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
        inside: false,
      },
    },
  },
  tooltip: {
    enabled: false,
  },
  xAxis: {
    type: 'datetime',
    tickInterval: 1000 * 60 * 60 * 6,
    min: Date.UTC(1970, 1, 1, 0, 0, 0),
    max: Date.UTC(1970, 1, 1, 24, 0, 0),
    labels: {
      formatter() {
        const date = new Date(this.value);
        const days = date.getUTCDate();

        return days === 2 ? '24:00' : date.toUTCString().substring(17, 22);
      },
      style: {
        color: '#000000',
      },
    },
    lineColor: '#EAEAEA',
    minorTicks: false,
    tickLength: 0,
  },
  yAxis: {
    title: {
      text: '',
    },
    reversed: false,
    visible: false,
    max: 20,
    min: 0,
  },
  series: [
    {
      name: '',
      borderColor: '#FFFFFF',
      borderRadius: 0,
      pointWidth: 40,
      type: 'xrange',
      dataLabels: [
        {
          align: 'left',
          formatter(): number {
            return this.y + 1;
          },
          x: -5,
          y: -10,
          inside: false,
        },
      ],
    },
  ],
};
